import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import LoadingSpinner from "./UI/LoadingSpinner";

const AdminProtectedRoute = () => {
  console.log("🔍 AdminProtectedRoute rendu");
  
  const { user, userRole, loading } = useAuth();

  console.log("🔍 AdminProtectedRoute state:", { 
    loading, 
    userId: user?.id,
    userEmail: user?.email,
    userRole,
    timestamp: new Date().toISOString() 
  });

  if (loading) {
    console.log("⏳ Toujours en chargement... loading:", loading);
    return <LoadingSpinner />;
  }

  if (!user) {
    console.log("❌ Pas d'utilisateur - user:", user);
    return <Navigate to="/login" replace />;
  }

  // Vérifie le rôle - accepte super_admin, admin et formateur
  const allowedRoles = ['super_admin', 'admin', 'formateur'];
  const isAuthorized = allowedRoles.includes(userRole);
  
  console.log("🔍 Vérification autorisation - userRole:", userRole, "isAuthorized:", isAuthorized);

  if (!isAuthorized) {
    console.log("❌ Rôle insuffisant - userRole:", userRole);
    return <Navigate to="/unauthorized" replace />;
  }

  console.log("✅ Utilisateur autorisé - affichage admin");
  return <Outlet />;
};

export default AdminProtectedRoute;